import { useState } from 'react';

import type {
  OpportunityAssessment
} from '../types/apiTypes';
import usePaginatedList from './usePaginatedList';

const RESOURCE_REFETCH_INTERVAL_MS = 10000;

export const DEFAULT_RESOURCE_SORTING_FIELD = 'Created At';
const DEFAULT_SORTING_DIRECTION = 'DESC';
export const ASSESSMENT_LABEL_TO_DB_FIELD_MAP = new Map<string, string>([
  ['Created At', 'created_at']
]);

const useOpportunityAssessmentListData = (organizationSlug: string) => {
  const queryParams = {
    organization_slug: organizationSlug ?? ''
  };
  const [refetchingEnabled, setRefetchingEnabled] = useState(false);

  const {
    formattedData,
    pageCount,
    isLoading,
    pagination,
    onPaginationChange
  } = usePaginatedList<OpportunityAssessment>({
    defaultSortingField: DEFAULT_RESOURCE_SORTING_FIELD,
    defaultSortDirection: DEFAULT_SORTING_DIRECTION,
    route: '/app/opportunity-assessments',
    queryParams,
    labelToDBFieldMap: ASSESSMENT_LABEL_TO_DB_FIELD_MAP,
    queryConfig: {
      refetchInterval: refetchingEnabled ? RESOURCE_REFETCH_INTERVAL_MS : undefined
    }
  });

  const shouldRefetch = formattedData.items.some(
    (i) => i.processing_status !== 'COMPLETE' || i.opportunity.processing_status !== 'COMPLETE'
  );
  if (refetchingEnabled !== shouldRefetch) {
    setRefetchingEnabled(shouldRefetch);
  }
  const setPageIndex = (index: number) => {
    onPaginationChange({ ...pagination, pageIndex: index });
  };
  return {
    opportunityAssessments: formattedData.items,
    total: formattedData.total,
    isLoading,
    pageCount,
    pagination,
    setPageIndex
  };
};

export default useOpportunityAssessmentListData;
